import React from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "./app_bar.component";
import AppBarMobile from "./app_bar.componentMobile";

class TopAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileView: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    let currentHideNav = window.innerWidth <= 760;
    // console.log(currentHideNav);
    if (currentHideNav !== this.state.mobileView) {
      this.setState({ mobileView: currentHideNav });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  render() {
    return <div>{this.state.mobileView ? <AppBarMobile /> : <AppBar />}</div>;
  }
}

TopAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default TopAppBar;
